import {Exclude, Expose, instanceToPlain, plainToInstance, Transform} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../../web/validation";
import {Entity} from "../entity";
import {getDatabaseCodeTransformer} from "../transfomers/transformers";
import {ServiceEventTargetMode, toServiceEventTargetMode} from "./service-event-target-mode";

export const ServiceEventTargetCodec = t.intersection([
  t.type({
    id: t.string,
    serviceEventId: t.string,
    objectId: t.string,
    objectType: t.string,
    targetMode: t.string,
    createDttm: t.number,
    lastModifiedDttm: t.number,
  }),
  t.partial({
    reason: t.string,
    createdById: t.string,
    lastModifiedById: t.string,
  }),
]);

export type ServiceEventTarget = t.TypeOf<typeof ServiceEventTargetCodec>;

@Exclude()
export class ServiceEventTargetEntity implements Entity {
  @Expose()
  id!: string;

  @Expose()
  serviceEventId!: string;

  @Expose()
  objectId!: string;

  @Expose()
  objectType!: string;

  @Transform(getDatabaseCodeTransformer(toServiceEventTargetMode))
  @Expose()
  targetMode!: ServiceEventTargetMode;

  @Expose()
  reason?: string;

  @Expose()
  createdById?: string;

  @Expose()
  lastModifiedById?: string;

  @Expose()
  createDttm!: number;

  @Expose()
  lastModifiedDttm!: number;

  readonly entityType = 'SVCEVENTTARGET';

  get displayName(): Readonly<string> {
    return this.id;
  }

  /**
   * Constructor for ServiceEventTargetEntity. Recommend using the {@link create} method instead.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  static from(value: ServiceEventTarget): ServiceEventTargetEntity {
    return plainToInstance(ServiceEventTargetEntity, value, {
      excludeExtraneousValues: true,
    });
  }

  loadTypeValue(): Promise<ServiceEventTarget> {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSON(ServiceEventTargetCodec, object);
  }

  asTypeValue(): ServiceEventTarget {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSONNow(ServiceEventTargetCodec, object);
  }
}
